import React from 'react';
import { XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, BarChart, Bar, Legend} from 'recharts';
import { money } from 'utils/helpers';

const formatTooltipLabel = (label) => `Customer Name: ${label}`;
const formatTooltipValue = (value, name, props) => {
  const labelMap = {
    value1: 'customerSales',
    value2: 'customerProfit',
  };
  return [`${value}`, labelMap[name] || name];
};

const CustomerRankChart = (props) => {
  return (
    // <ResponsiveContainer width="100%" height={300}>
    //   <BarChart data={props.data} margin={{ top: 20, right: 30, left: 70, bottom: 5 }}>
    //     <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
    //     <XAxis dataKey="customerName" />
    //     <YAxis tickMargin={10} tickFormatter={(value) => money(value)} />
    //     <Tooltip formatter={(value) => [`Rp ${money(value)}`, 'Sales']} />
    //     <Bar type="monotone" dataKey="customerSales" stroke="#8884d8" />
    //     <Bar type="monotone" dataKey="customerProfit" stroke="#8884d8" />
    //   </BarChart>
    // </ResponsiveContainer>

    <ResponsiveContainer width="100%" height={props.height}>
      <BarChart
        layout="vertical"
        data={props.data}
        margin={{ top: 20, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" tickFormatter={(value) => money(value)} />
        <YAxis dataKey="customerName" type="category" width={200} />
        <Tooltip 
          formatter={(value) => [`Rp ${money(String(Math.floor(value)))}`]} 
          // formatter={formatTooltipValue}
          // labelFormatter={formatTooltipLabel}
        />
        <Legend />
        <Bar dataKey="customerSales" fill="#8884d8" />
        <Bar dataKey="customerProfit" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomerRankChart;
